import { supabase } from "./supabaseClient";
import { APP_VERSION } from "./pwaUpdate";
import { markSuccessfulFeedback } from "./feedbackRecognition";
import { getAnonymousFeedbackId } from "./feedbackIdentity";

export { getAnonymousFeedbackId };

export const submitFeedback = async ({ stars, chips, comment, userId, origin, context }) => {
  const payload = {
    stars,
    chips,
    comment: comment.trim() || null,
    user_id: userId || null,
    anonymous_id: userId ? null : getAnonymousFeedbackId(),
    submitted_at: new Date().toISOString(),
    origin,
    screen_context: context || { screen: "unknown" },
    app_version: APP_VERSION,
    metadata: { schema_version: 1, source: "feedback_form" },
  };
  const { error } = await supabase.from("feedback").insert([payload]);
  if (error) throw error;
  markSuccessfulFeedback(userId);
  return payload;
};
